export default "__VITE_ASSET__Dr0v9iCM__"